import React from "react";
import { Link } from "react-router-dom";
import { Check } from "lucide-react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

export default function SubmissionSuccess() {
    return (
        <div className="App min-h-screen flex flex-col">
            <Navbar />
            <main className="flex-1">
                <section className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 py-24 text-center" data-testid="success-section">
                    <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-tmc-moss/15 mb-8">
                        <Check className="w-7 h-7 text-tmc-moss" strokeWidth={2.5} />
                    </div>
                    <div className="label-overline">Received with care</div>
                    <h1 className="font-serif text-4xl sm:text-5xl text-tmc-ink mt-5 leading-tight">
                        Thank you for sharing.
                    </h1>
                    <p className="mt-6 text-lg text-tmc-inkSoft leading-relaxed">
                        Your moment is now in the hands of our team. We read every story with attention. If
                        chosen as a finalist, it will appear (anonymously) for the team to honor at our live
                        gathering.
                    </p>
                    <div className="mt-10 flex flex-col sm:flex-row justify-center gap-4">
                        <Link to="/submit" className="tmc-btn-secondary" data-testid="success-share-another">
                            Share another
                        </Link>
                        <Link to="/" className="tmc-btn-primary" data-testid="success-home">
                            Back to home
                        </Link>
                    </div>
                </section>
            </main>
            <Footer />
        </div>
    );
}
